'use strict';
angular.module('reporting.dashboards.services')
    .service('metricsService', [
    '$interval',
    'rsEnvironment',
    'utils',
    '$http',
    'userActionList',
    'rsState',
    function ($interval, env, utils, $http, userActionList, rsState) {
        var trackingEnabled = true;
        var standardProperties = {
            surveyId: undefined,
            reportId: undefined
        };
        var loadedPageIds = [];
        var savedFilterIds;
        var publicReportKeys = ['publicEnabled', 'privateEnabled', 'accessCode'];
        var metricProperties = {
            ACCESS_CODE_REQ: 'accessCodeProtectionActive',
            ATTACHMENT: 'attachment',
            BREAKOUT_BY: {
                TO: 'toBreakoutBy',
                FROM: 'fromBreakoutBy',
                SIMPLE: 'breakoutBy'
            },
            CONTENT: 'content',
            COPIED: 'copied',
            CREATE_NEW: 'createNew',
            FILTER_ACTIVE: 'filterActive',
            FORMAT: 'format',
            METRIC: {
                TO: 'toMetric',
                FROM: 'fromMetric',
                SIMPLE: 'metric'
            },
            NUM_CHARS: 'numChars',
            NUM_PAGES: 'numPages',
            NUM_TO: 'numTo',
            NUM_VIS: 'numVisualizations',
            OPTION: 'option',
            PAGE_ID: 'pageId',
            PAGE_INDEX: 'pageIndex',
            PAGE_TYPE: 'pageType',
            PUBLIC_REPORT_ACTIVE: 'publicReportActive',
            REPORT_BREAKOUT: 'reportBreakoutActive',
            RESULTS: 'numResults',
            SOURCE: 'source',
            TYPE: 'type',
            VIS: {
                TO: 'toVisualization',
                FROM: 'fromVisualization'
            },
            WHEN: 'when'
        };
        var BREAKOUT_CHANGE_EVENT = 'Report.BreakoutBy.Change', CHANGE_SETTINGS_EVENT = 'ReportSettings.Change', COPY_PUBLIC_LINK_EVENT = 'PublicReportLink.Copy', DASHBOARDS_OPT_IN_EVENT = 'ResultsDashboards.OptIn', DEFAULT_SETTINGS_EVENT = 'ReportSettings.Default', DELETE_REPORT_EVENT = 'Report.Delete', DOWNLOAD_EVENT = 'PublicReport.Download', EDIT_REPORT_EVENT = 'EditReport.Complete', EMAIL_EVENT = 'ScheduleReportEmail.Complete', EXPORT_EVENT = 'Export.Complete', FILTER_EVENT = {
            ADD: 'Filter.Add',
            REMOVE: 'Filter.Remove',
            MANAGE: 'Filter.Manage'
        }, PAGE_LAND_EVENT = 'PageLand', MANAGE_PUBLIC_EVENT = 'ManagePublicReport.Change', NEW_REPORT_EVENT = 'NewReport.Complete', NOTE_EVENT = {
            ADD: 'Note.Add',
            REMOVE: 'Note.Remove'
        }, PAGE_EVENT = {
            ADD: 'CreateCustomPage.Click',
            HIDE: 'HidePage.Click',
            NAV: 'PageNavigate.Click',
            REMOVE: 'DeleteCustomPage.Click',
            SEARCH: 'PageSearch.Complete'
        }, VIEW_REPORT_EVENT = 'PublicReport.View', VIEW_PAGE_EVENT = 'PublicReport.PageView', VIS_EVENT = {
            ADD: 'Visualization.Add',
            BREAKOUT: 'Visualization.BreakoutBy.Change',
            METRIC: 'Visualization.Metric.Change',
            REMOVE: 'Visualization.Remove',
            TYPE: 'Visualization.Type.Change'
        };
        var DEFAULT_TYPES = {
            QUALTRICS: 'Apply Qualtrics Default',
            SAVE: 'Save As My Default',
            USE: 'Apply My Default'
        }, FORMAT_TYPES = {
            csv: 'CSV',
            docx: 'Word',
            pdf: 'PDF',
            png: 'PNG',
            pptx: 'PowerPoint',
            raw: 'Raw Data'
        }, metaKeys = ['startDate', 'endDate', 'status', 'ipAddress', 'progress',
            'duration', 'finished', 'recordedDate', 'responseSetName', '_cachedDate',
            '_recordId', 'responseSet', 'userLanguage'], contactKeys = ['distributionChannel', 'externalDataReference', 'recipientLastName',
            'recipientFirstName', 'recipientEmail'];
        function enableEventTracking() {
            trackingEnabled = true;
        }
        function disableEventTracking() {
            trackingEnabled = false;
        }
        function _isTractiveRunning() {
            return window.tractive && window.tractive.isRunning;
        }
        function trackEvent(eventName, properties) {
            _.assign(properties, standardProperties);
            if (trackingEnabled && _isTractiveRunning()) {
                window.tractive.track('CPR', eventName, properties);
            }
        }
        function _countVisiblePagesAndVisualizations(pages) {
            var numVis = 0, numPages = 0;
            _.forEach(pages, function (page) {
                // Ignore hidden pages
                if (!(page.meta && page.meta.hidden)) {
                    numVis += (page.widgets && page.widgets.length) || 0;
                    numPages++;
                }
            });
            return {
                vis: numVis,
                pages: numPages
            };
        }
        function _countPages(container) {
            return (container && container.pages && container.pages.length) || 0;
        }
        function _countVisualizations(container) {
            var pages = (container && container.pages) || [];
            var numWidgets = 0;
            _.forEach(pages, function (page) {
                numWidgets += (page.widgets && page.widgets.length) || 0;
            });
            return numWidgets;
        }
        function _isEmbeddedDataField(field) {
            // Copied from fieldset-view-menu-service/filters-client
            return field && field.meta && _.contains(field.meta.fullType, 'ED') || false;
        }
        function _isSurveyMetaField(field) {
            // Copied from prc fields-service
            var key = field && field.fieldId && field.fieldId.split(':')[0];
            return _.contains(metaKeys, key);
        }
        function _isContactField(field) {
            // Copied from fieldset-filters/filters-client
            return _.contains(contactKeys, field && field.fieldId);
        }
        function _getDataType(field) {
            if (field && field.fields) {
                field = field.fields[0];
            }
            if (!field) {
                return 'none';
            }
            else if (_isSurveyMetaField(field)) {
                return 'Survey Metadata';
            }
            else if (_isContactField(field)) {
                return 'Contact Fields';
            }
            else if (_isEmbeddedDataField(field)) {
                return 'Embedded Data';
            }
            else if (field.fieldId) {
                return 'Question';
            }
            return 'none';
        }
        function pageLand(report) {
            var properties = {};
            var container = (report && report.container) || {};
            standardProperties = {
                surveyId: env.get('surveyId'),
                reportId: env.get('containerId')
            };
            properties[metricProperties.NUM_VIS] = _countVisualizations(container);
            properties[metricProperties.NUM_PAGES] = _countPages(container);
            properties[metricProperties.FILTER_ACTIVE] = !!container.filters;
            properties[metricProperties.PUBLIC_REPORT_ACTIVE] = !!(container.contextMeta && container.contextMeta.publicEnabled);
            properties[metricProperties.REPORT_BREAKOUT] = !!(container.contextMeta && container.contextMeta.globalBreakout);
            if (!_isTractiveRunning()) {
                var tractiveReady = $interval(function () {
                    try {
                        if (_isTractiveRunning()) {
                            trackEvent(PAGE_LAND_EVENT, properties);
                            $interval.cancel(tractiveReady);
                        }
                    }
                    catch (e) {
                        $interval.cancel(tractiveReady);
                        console.log(e);
                    }
                }, 100);
            }
            else {
                trackEvent(PAGE_LAND_EVENT, properties);
            }
        }
        function newReport(copied) {
            var properties = {};
            properties[metricProperties.COPIED] = copied;
            trackEvent(NEW_REPORT_EVENT, properties);
        }
        function viewPublicReport(report) {
            var properties = {};
            var container = (report && report.container) || {};
            var pages = (container && container.pages) || [];
            standardProperties.surveyId = container && container.contextMeta && container.contextMeta.surveyId;
            standardProperties.reportId = container && container._id;
            loadedPageIds = _.map(container.pages, function (page) {
                return page._id;
            });
            var counts = _countVisiblePagesAndVisualizations(pages);
            properties[metricProperties.NUM_VIS] = counts.vis;
            properties[metricProperties.NUM_PAGES] = counts.pages;
            if (!_isTractiveRunning()) {
                var tractiveReady = $interval(function () {
                    try {
                        if (_isTractiveRunning()) {
                            trackEvent(VIEW_REPORT_EVENT, properties);
                            $interval.cancel(tractiveReady);
                        }
                    }
                    catch (e) {
                        $interval.cancel(tractiveReady);
                        console.log(e);
                    }
                }, 100, 50);
            }
            else {
                trackEvent(VIEW_REPORT_EVENT, properties);
            }
        }
        function viewPublicPage(page) {
            var pageId = page && page._id;
            var index = pageId ? loadedPageIds.indexOf(pageId) : undefined;
            var properties = {};
            properties[metricProperties.PAGE_INDEX] = (index === -1) ? undefined : index;
            properties[metricProperties.PAGE_ID] = pageId;
            properties[metricProperties.NUM_VIS] = (page && page.widgets && page.widgets.length) || 0;
            _checkStandardProperties();
            trackEvent(VIEW_PAGE_EVENT, properties);
        }
        function downloadReport(pages) {
            var properties = {};
            var counts = _countVisiblePagesAndVisualizations(pages || []);
            properties[metricProperties.NUM_PAGES] = counts.pages;
            properties[metricProperties.NUM_VIS] = counts.vis;
            _checkStandardProperties();
            trackEvent(DOWNLOAD_EVENT, properties);
        }
        function _checkStandardProperties() {
            if (_.isUndefined(standardProperties.surveyId)) {
                standardProperties.surveyId = env.get('surveyId');
            }
            if (_.isUndefined(standardProperties.reportId)) {
                standardProperties.reportId = env.get('containerId');
            }
        }
        function managePublicReport(oldMeta) {
            var properties = {};
            var contextMeta = env.get('contextMeta');
            var oldValues = _.pick(oldMeta, publicReportKeys);
            var newValues = _.pick(contextMeta, publicReportKeys);
            if (_.isEqual(oldValues, newValues)) {
                return;
            }
            properties[metricProperties.PUBLIC_REPORT_ACTIVE] = !!(contextMeta && contextMeta.publicEnabled);
            properties[metricProperties.ACCESS_CODE_REQ] = (contextMeta && contextMeta.publicEnabled) ? !!contextMeta.privateEnabled : 'none';
            trackEvent(MANAGE_PUBLIC_EVENT, properties);
        }
        function copyPublicLink() {
            var properties = {};
            var contextMeta = env.get('contextMeta');
            properties[metricProperties.ACCESS_CODE_REQ] = !!(contextMeta && contextMeta.privateEnabled);
            trackEvent(COPY_PUBLIC_LINK_EVENT, properties);
        }
        function deleteReport(container) {
            var properties = {};
            properties[metricProperties.NUM_VIS] = _countVisualizations(container);
            properties[metricProperties.NUM_PAGES] = _countPages(container);
            trackEvent(DELETE_REPORT_EVENT, properties);
        }
        function editReport() {
            trackEvent(EDIT_REPORT_EVENT, {});
        }
        function changeReportSettings(newContextMeta) {
            var oldContextMeta = _.cloneDeep(env.get('contextMeta'));
            var statsDateProps = '.widgetOptions.viewresults-statstable.privateData.lastModifiedDate';
            var simpleDateProps = '.widgetOptions.viewresults-simpletable.privateData.lastModifiedDate';
            _.forEach([statsDateProps, simpleDateProps], function (props) {
                utils.setExistingProps(newContextMeta, props, null);
                utils.setExistingProps(oldContextMeta, props, null);
            });
            if (!_.isEqual(oldContextMeta, newContextMeta)) {
                trackEvent(CHANGE_SETTINGS_EVENT, {});
            }
        }
        function defaultSettings(option) {
            var properties = {};
            if (_.contains(DEFAULT_TYPES, option)) {
                properties[metricProperties.OPTION] = option;
            }
            trackEvent(DEFAULT_SETTINGS_EVENT, properties);
        }
        function changeBreakout(newBreakout) {
            var properties = {};
            var contextMeta = env.get('contextMeta');
            var oldBreakout = contextMeta && contextMeta.globalBreakout;
            if (_.isEqual(oldBreakout, newBreakout)) {
                return;
            }
            properties[metricProperties.BREAKOUT_BY.FROM] = _getDataType(oldBreakout);
            properties[metricProperties.BREAKOUT_BY.TO] = _getDataType(newBreakout);
            trackEvent(BREAKOUT_CHANGE_EVENT, properties);
        }
        function _manageFilter(filterIdObj, filters, fieldSet) {
            var properties = {};
            var url = '/filters-service/v1/fieldsets/' + env.get('fieldSetId')
                + '/filters?surveyId=' + env.get('surveyId');
            var previousFilter = _.cloneDeep(env.get('pageFilters')); // Need to get before async call
            $http.get(url).then(function (res) {
                var newFilters = _.map(res.data && res.data.filters, 'filterId');
                var oldFilters = savedFilterIds || _.map(fieldSet && fieldSet.fscsFilters, 'filterId');
                properties[metricProperties.CREATE_NEW] = !!(_.difference(newFilters, oldFilters).length);
                savedFilterIds = _.cloneDeep(newFilters);
                trackEvent(FILTER_EVENT.MANAGE, properties);
                _addFilter(filterIdObj, filters, fieldSet, previousFilter); // Also log event if a new filter was applied
            });
        }
        // Debounce to reduce events when typing or multi-select during filter add
        var _debounceTrackAddFilter = _.debounce(trackEvent, 2000);
        function _addFilter(filterIdObj, filters, fieldSet, previousFilter) {
            var properties = {};
            var currentFilter = previousFilter || env.get('pageFilters');
            // Don't fire if the same as existing filter
            if (_.isEqual(_.omit(currentFilter, _.isUndefined), _.omit(filters, _.isUndefined)) ||
                (filters && filters.filterId && (filters.filterId === (currentFilter && currentFilter.filterId)))) {
                return;
            }
            // Get full field info from the fieldSetView
            var fieldId = utils.getProps(filters, 'filter.field');
            var field = _.filter(fieldSet && fieldSet.fieldSetView, { 'fieldId': fieldId })[0] || fieldId;
            properties[metricProperties.TYPE] = (filterIdObj && filterIdObj.filterId) ? 'Saved Filter' : _getDataType(field);
            _debounceTrackAddFilter(FILTER_EVENT.ADD, properties);
        }
        function changeFilter(filterIdObj, removed, filters, fieldSet) {
            var modal = document.getElementsByClassName('modal')[0];
            var isFilterModalOpen = !!(modal && utils.getProps(modal, 'attributes.1.value') === 'fc.FiltersModalController');
            if (removed) {
                trackEvent(FILTER_EVENT.REMOVE, {});
                return;
            }
            else if (isFilterModalOpen) {
                _manageFilter(filterIdObj, filters, fieldSet);
            }
            else {
                _addFilter(filterIdObj, filters, fieldSet);
            }
        }
        function startExport(exportType, content) {
            var properties = {};
            switch (content) {
                case userActionList.EXPORT_PAGE:
                    properties[metricProperties.CONTENT] = 'Page';
                    break;
                case userActionList.EXPORT_WIDGET:
                    properties[metricProperties.CONTENT] = 'Visualization';
                    break;
                case userActionList.EXPORT_REPORT:
                default:
                    properties[metricProperties.CONTENT] = 'Report';
                    break;
            }
            properties[metricProperties.FORMAT] = FORMAT_TYPES[exportType];
            trackEvent(EXPORT_EVENT, properties);
        }
        function scheduledReport(emailData) {
            var properties = {};
            emailData = emailData || {};
            var data = emailData.data || {};
            var weekDayFromCron = _.last(utils.getProps(emailData, 'scheduledTime.0'));
            var when = (weekDayFromCron === '?') ? 'Monthly' : 'Weekly';
            properties[metricProperties.ATTACHMENT] = FORMAT_TYPES[data.attachmentType];
            properties[metricProperties.NUM_TO] = data.recipient && (data.recipient.contactId ? 1 : data.recipient.count) || 0;
            properties[metricProperties.WHEN] = _.isUndefined(weekDayFromCron) ? weekDayFromCron : when;
            trackEvent(EMAIL_EVENT, properties);
        }
        function addNote() {
            trackEvent(NOTE_EVENT.ADD, {});
        }
        function addVisualization(widgetType) {
            var properties = {};
            properties[metricProperties.TYPE] = widgetType;
            trackEvent(VIS_EVENT.ADD, properties);
        }
        function removeVisualization(widget, pageId) {
            if (!widget) {
                return;
            }
            if (widget._type === 'viewresults.richtext') {
                trackEvent(NOTE_EVENT.REMOVE, {});
                return;
            }
            return rsState.getConfig(widget._id, pageId, env.get('containerId'))
                .then(function (widgetData) {
                var properties = {};
                properties[metricProperties.TYPE] = widget._type;
                var metric = utils.getProps(widgetData, 'data.metric');
                properties[metricProperties.METRIC.SIMPLE] = metric || 'default';
                var breakout = utils.getProps(widgetData, 'data.breakouts') || 'default';
                properties[metricProperties.BREAKOUT_BY.SIMPLE] = _.isString(breakout) ? breakout : _getDataType(breakout);
                trackEvent(VIS_EVENT.REMOVE, properties);
            });
        }
        function addPage() {
            trackEvent(PAGE_EVENT.ADD, {});
        }
        function removePage(page) {
            var properties = {};
            properties[metricProperties.NUM_VIS] = utils.getProps(page, 'widgets.length') || 0;
            trackEvent(PAGE_EVENT.REMOVE, properties);
        }
        function hidePage(page, fromCheckbox) {
            var properties = {};
            properties[metricProperties.NUM_VIS] = utils.getProps(page, 'widgets.length') || 0;
            properties[metricProperties.SOURCE] = fromCheckbox ? 'Checkbox' : 'Page Options Dropdown';
            properties[metricProperties.PAGE_TYPE] = utils.getProps(page, 'meta.sourceId') ? 'default' : 'custom';
            trackEvent(PAGE_EVENT.HIDE, properties);
        }
        function navigateToPage(pageIndex, isFromSearch) {
            var properties = {};
            properties[metricProperties.PAGE_INDEX] = pageIndex;
            properties[metricProperties.SOURCE] = isFromSearch ? 'Search' : 'Direct Click';
            trackEvent(PAGE_EVENT.NAV, properties);
        }
        function searchComplete(numSearchChars, numFilteredPages) {
            var properties = {};
            properties[metricProperties.NUM_CHARS] = numSearchChars;
            properties[metricProperties.RESULTS] = numFilteredPages;
            trackEvent(PAGE_EVENT.SEARCH, properties);
        }
        function changeVisualizationType(oldType, newWidget) {
            var properties = {};
            var newWidgetName = utils.getProps(newWidget, 'widget.author') + '.' + utils.getProps(newWidget, 'widget.name');
            properties[metricProperties.VIS.FROM] = oldType;
            properties[metricProperties.VIS.TO] = newWidgetName;
            trackEvent(VIS_EVENT.TYPE, properties);
        }
        function changeVisualizationMetric(oldMetric, newMetric) {
            var properties = {};
            properties[metricProperties.METRIC.FROM] = oldMetric;
            properties[metricProperties.METRIC.TO] = newMetric;
            trackEvent(VIS_EVENT.METRIC, properties);
        }
        function changeVisualizationBreakout(oldBreakout, newBreakout) {
            var properties = {};
            properties[metricProperties.BREAKOUT_BY.FROM] = _getDataType(oldBreakout);
            properties[metricProperties.BREAKOUT_BY.TO] = _getDataType(newBreakout);
            trackEvent(VIS_EVENT.BREAKOUT, properties);
        }
        function dashboardsOptIn() {
            trackEvent(DASHBOARDS_OPT_IN_EVENT, {});
        }
        return {
            enableEventTracking: enableEventTracking,
            disableEventTracking: disableEventTracking,
            trackEvent: trackEvent,
            pageLand: pageLand,
            newReport: newReport,
            viewPublicReport: viewPublicReport,
            viewPublicPage: viewPublicPage,
            downloadReport: downloadReport,
            managePublicReport: managePublicReport,
            copyPublicLink: copyPublicLink,
            deleteReport: deleteReport,
            editReport: editReport,
            changeReportSettings: changeReportSettings,
            defaultSettings: defaultSettings,
            DEFAULT_TYPES: DEFAULT_TYPES,
            changeBreakout: changeBreakout,
            changeFilter: changeFilter,
            startExport: startExport,
            scheduledReport: scheduledReport,
            addNote: addNote,
            addVisualization: addVisualization,
            removeVisualization: removeVisualization,
            addPage: addPage,
            removePage: removePage,
            hidePage: hidePage,
            navigateToPage: navigateToPage,
            searchComplete: searchComplete,
            changeVisualizationType: changeVisualizationType,
            changeVisualizationMetric: changeVisualizationMetric,
            changeVisualizationBreakout: changeVisualizationBreakout,
            dashboardsOptIn: dashboardsOptIn,
            __TESTING__: {
                _isEmbeddedDataField: _isEmbeddedDataField,
                _isSurveyMetaField: _isSurveyMetaField,
                _isContactField: _isContactField
            }
        };
    }
]);
